import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './Home'
import About from './About'
import './App.css'
import Contact from './Contact';
import Gallery from './Gallery';
import Test from './Test';
import Test2 from './Test2';

export default function App() {

  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/gallery' element={<Gallery />} />
          <Route path='/test' element={<Test />} />
          <Route path='/test-2' element={<Test2 />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}